export default __webpack_public_path__ + "static/media/gallery_04.1f6b2480.jpg";